"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const VideocamOutlined_1 = __importDefault(require("@material-ui/icons/VideocamOutlined"));
const VideocamOffOutlined_1 = __importDefault(require("@material-ui/icons/VideocamOffOutlined"));
const IconButton_1 = __importDefault(require("../IconButton"));
const styles_1 = __importDefault(require("./styles"));
const VideocamToggle = ({ id = 'videocam', label, loading = false, onChange, value, }) => {
    const classes = styles_1.default({ value });
    return (react_1.default.createElement(IconButton_1.default, { id: id, loading: loading, disabled: loading, label: label, onClick: () => onChange(!value), ariaLabel: id },
        react_1.default.createElement("span", { className: classes.icon }, value ? react_1.default.createElement(VideocamOutlined_1.default, null) : react_1.default.createElement(VideocamOffOutlined_1.default, null))));
};
exports.default = VideocamToggle;
